import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';
import CommonJournalDetailList from 'components/modules/accounting/journal/list/CommonJournalDetailList';

const CommonJournalPopup = (props) => {
    const {
        recordId,
        showPopup,
        postedDate,
        isAlreadyPosted,
        onToogleModal,
        journalType,
        showJournalReturned,
    } = props;

    const useOwnStyle = makeStyles(() => ({
        modalContainer: {
            height: 900,
            ...(!showJournalReturned ? {
                '& > div': {
                    height: '100%',
                },
            } : {}),
            '& > div > div > div > div': {
                minHeight: showJournalReturned ? 408 : '100%',
                minWidth: 'fit-content',
            },
        },
        appBar: {
            padding: '15px 16px',
        },
    }));

    const theme = useTheme();
    const classes = useOwnStyle();
    const { modalContainer, ...appBarClasses } = classes;
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const returnedJournalRef = useRef(null);

    const handlePostToAccounting = () => returnedJournalRef.current?.getData();
    const clearJournalRef = useCallback(() => {
        if (returnedJournalRef.current && returnedJournalRef.current.reset) {
            returnedJournalRef.current.reset();
        }

        returnedJournalRef.current = null;
    }, []);

    return (
        <Dialog
            open={showPopup}
            maxWidth="lg"
            fullScreen={isMobile}
            fullWidth={!isMobile}
            disableBackdropClick
            disableEscapeKeyDown
            scroll="paper"
        >
            <DialogAppBar
                classes={{ ...appBarClasses }}
                title={isAlreadyPosted ? 'Reverting Journal' : 'Posting Journal'}
                onClose={onToogleModal}
                titleVariant="subtitle1"
                toolbarSize="sm"
            />
            <DialogContent className={modalContainer}>
                <CommonJournalDetailList
                    recordId={recordId}
                    journalType={journalType}
                    writePermissions={!isAlreadyPosted}
                    showPosted={isAlreadyPosted}
                    initialPostedDate={postedDate}
                    onCompleted={onToogleModal}
                    onPost={handlePostToAccounting}
                    clearRef={clearJournalRef}
                />
                {showJournalReturned && (
                    <CommonJournalDetailList
                        recordId={recordId}
                        journalType={journalType}
                        writePermissions={!isAlreadyPosted}
                        showPosted={isAlreadyPosted}
                        initialPostedDate={postedDate}
                        onCompleted={onToogleModal}
                        isReturned
                        ref={returnedJournalRef}
                    />
                )}
            </DialogContent>

        </Dialog>
    );
};

CommonJournalPopup.propTypes = {
    recordId: PropTypes.number.isRequired,
    postedDate: PropTypes.string,
    showPopup: PropTypes.bool.isRequired,
    isAlreadyPosted: PropTypes.bool.isRequired,
    onToogleModal: PropTypes.func.isRequired,
    journalType: PropTypes.string.isRequired,
    showJournalReturned: PropTypes.bool,
};

CommonJournalPopup.defaultProps = {
    postedDate: null,
    showJournalReturned: false,
};

export default CommonJournalPopup;
